import { mapState, mapGetters } from 'vuex';
import moment from 'moment';
import VueLoadImage from 'vue-load-image';
import * as mutationTypes from '@/vuex/mutation-types';
import Pagination from '@/components/Pagination';
import { apiPhotoUrl } from '@/plugin/api';

export default {
    data() {
        return {
            pagination: {
                pageSize: 10,
                currentPage: 1,
                total: 0,
                totalPages: 0,
            },
            apiPhotoUrl,
        };
    },
    computed: {
        ...mapState({
            httpStatus: (state) => state.httpStatus,
            alertData: (state) => state.alertData,
            confirmData: (state) => state.confirmData,
            pageData: (state) => state.pageData,
        }),
        ...mapState('userData', ['currentPosition']),
        ...mapState('dataList', ['mappings']),
        ...mapGetters('userData', ['isInValidScope']),
    },
    created() {},
    methods: {
        /**
         * 所有欄位驗證
         * @param {Function} callback 驗證通過回呼
         */
        validateForm(callback) {
            this.$store.dispatch(mutationTypes.pageData.setIsFirstEdit, false);
            this.$validator.validateAll().then((isValid) => {
                // console.log('驗證有無通過', isValid);
                if (!isValid) {
                    // eslint-disable-next-line no-alert
                    this.commonAlert('請填寫必填欄位或格式錯誤！');
                    return;
                }
                if (callback) callback();
            });
        },
        /**
         * 清除欄位驗證
         */
        clearValidate() {
            this.errors.clear();
            this.$store.dispatch(mutationTypes.pageData.setIsFirstEdit, true);
        },
        /**
         * 設定loading值
         * @param {Boolean} isLoading 是否載入中
         */
        setLoading(isLoading) {
            this.$store.dispatch(
                mutationTypes.pageData.setIsLoading,
                isLoading,
            );
        },
        /**
         * request 錯誤處理
         * @param {Object} err 錯誤物件
         */
        errorHandler(err) {
            if (err) {
                switch (err.response.status) {
                    case 400:
                    case 403:
                    case 404:
                    case 500:
                        this.$store.dispatch(
                            mutationTypes.httpStatus.setIsShow,
                            !this.httpStatus.isShow,
                        );
                        this.$store.dispatch(
                            mutationTypes.httpStatus.setStatusCode,
                            err.response.status,
                        );
                        break;
                    default:
                        this.$store.dispatch(
                            mutationTypes.httpStatus.setStatusCode,
                            err.response.status,
                        );
                        break;
                }
                // eslint-disable-next-line no-console
                console.log('ErrorHandler: ', err);
                this.setLoading(false);
            }
        },
        /**
         * 客製提示視窗
         * @param {String} msg 文字訊息
         * @param {Function} callback 回呼
         * @param {Boolean} isShowCancelBtn 是否出現取消按鈕
         */
        commonAlert(msg, callback, isShowCancelBtn) {
            this.$store.dispatch(mutationTypes.alertData.setMsg, msg);
            this.$store.dispatch(
                mutationTypes.alertData.setIsShow,
                !this.alertData.isShow,
            );
            this.$store.dispatch(mutationTypes.alertData.setCallback, callback);
            this.$store.dispatch(
                mutationTypes.alertData.setIsShowCancelBtn,
                isShowCancelBtn,
            );
        },
        /**
         * 客製確認視窗
         * @param {String} msg 文字訊息
         * @param {Function} callback 回呼
         * @param {Boolean} isShowCancelBtn 是否出現取消按鈕
         * @param {Boolean} submitBtnText 送出按鈕文字
         */
        commonConfirm(msg, callback, isShowCancelBtn, submitBtnText) {
            this.$store.dispatch(mutationTypes.confirmData.setMsg, msg);
            this.$store.dispatch(
                mutationTypes.confirmData.setIsShow,
                !this.confirmData.isShow,
            );
            this.$store.dispatch(
                mutationTypes.confirmData.setCallback,
                callback,
            );
            this.$store.dispatch(
                mutationTypes.confirmData.setIsShowCancelBtn,
                isShowCancelBtn,
            );
            this.$store.dispatch(
                mutationTypes.confirmData.setSubmitBtnText,
                submitBtnText,
            );
        },
        goPage(routerName) {
            if (routerName.match('/')) {
                this.$router.push({ path: routerName });
            } else {
                this.$router.push({ name: routerName });
            }
            window.scroll(0, 0);
        },
        scrollToTop(scrollDuration) {
            const scrollStep = -window.scrollY / (scrollDuration / 15);
            const scrollInterval = setInterval(() => {
                if (window.scrollY !== 0) {
                    window.scrollBy(0, scrollStep);
                } else {
                    clearInterval(scrollInterval);
                }
            }, 15);
        },
        gaEvent(category, label) {
            this.$gtag.event('點擊', {
                event_category: category,
                event_label: label,
            });
        },
        /*
         * 格式化日期 YYYY-MM-DD
         */
        dateConvert(date, template) {
            const currentTemplate = template === undefined ? 'YYYY/MM/DD' : template;
            if (!date) {
                return '';
            }
            if (date.length === 7) {
                const y = date.substr(0, 2);
                const m = date.substr(3, 2);
                const d = date.substr(5, 2);
                return `民國${y}年${m}月-${d}日`;
            }

            if (date.length === 8) {
                const y = date.substr(0, 4);
                const m = date.substr(4, 2);
                const d = date.substr(6, 2);
                return `${y}-${m}-${d}`;
            }
            return moment(date).format(currentTemplate);
        },
        /**
         * 加入google行事曆
         * @param {string} text 事件名稱
         * @param {string} start 時間(起)
         * @param {string} end 時間(迄)
         */
        addGoogleCalendar(text, start, end) {
            const startTime = moment(start).format('YYYYMMDDThhmmss');
            const endTime = moment(end).format('YYYYMMDDThhmmss');
            const url = `https://calendar.google.com/calendar/u/0/r/eventedit?text=${text}&dates=${startTime}/${endTime}&trp=false&pli=1&sf=true`;

            const winRef = window.open(',', '_blank');
            setTimeout(() => {
                winRef.location = url;
            }, 0);
        },
        /**
         * 開啟google map顯示經緯度
         * @param {Array} coords 經緯度
         */
        googleMap(coords) {
            const url = `https://www.google.com.tw/maps/@${coords[1]},${coords[0]},18z`;
            const winRef = window.open(',', '_blank');
            setTimeout(() => {
                winRef.location = url;
            }, 0);
        },
        /**
         * 開啟google map導航
         * @param {Array} coords 經緯度
         */
        goGoogleMap(coords) {
            if (this.isInValidScope) {
                const url = `https://www.google.com/maps/dir/${this.currentPosition[1]}+${this.currentPosition[0]}/${coords[1]}+${coords[0]}`;
                window.open(url);
            } else {
                this.googleMap(coords);
            }
        },

        /**
         * 設定分頁訊息
         * @param {Object} pagination 分頁物件
         */
        setPagination(pagination) {
            ['pageSize', 'total', 'totalPages', 'currentPage'].forEach(
                (item) => {
                    if (pagination[item]) {
                        this.pagination[item] = pagination[item];
                    }
                },
            );
        },
    },
    filters: {},
    components: {
        Pagination,
        VueLoadImage,
    },
};
